import { Component, EventEmitter, Input, Output } from "@angular/core";

/**
 * Generated class for the KarnofskyToolComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "karnofsky-tool",
  templateUrl: "karnofsky-tool.html",
})
export class KarnofskyToolComponent {
  @Input() readonly: boolean = false;
  @Output() onValueUpdate: EventEmitter<any> = new EventEmitter();

  value;

  constructor() {
    // console.log('Hello KarnofskyToolComponent Component');
  }

  @Input() set existingData(data: object) {
    // console.log( "Tool received existing data: ", data );
    if (data !== undefined && data != null) {
      this.value = data["value"];
    }
  }

  valueChanged(value: number) {
    if (!this.readonly) {
      // console.log( "Value changed: ", value );
      this.value = value;
      this.onValueUpdate.emit({
        value: this.value,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/karnofsky-tool/karnofsky-tool.ts